import React, {
  useRef,
  useEffect,
  useState,
} from "../../../node_modules/react";
import Carousel from "../../../node_modules/react-bootstrap/Carousel";
import Banner01 from "../../assets/imagens/banner_webshopper_2020.b09e0a50.jpg";
import Banner02 from "../../assets/imagens/Banner-webshoppers-custom2020.199290c4.jpg";
import Banner03 from "../../assets/imagens/Banner-webshoppers-plus2020.jpg";
import BannerWs43 from "../../assets/imagens/BG-test.PNG";
import ImgBenx from "../../assets/imagens/01_Bexs_logo_tagline_secundario_transp_RGB.png";
import ImgWs43F from "../../assets/imagens/webshoppers/Capa-WB43Free2.PNG";
import ImgWs43P from "../../assets/imagens/webshoppers/Capa-WB43Premium2.png";
import ImgWs43C from "../../assets/imagens/webshoppers/Capa-WB43Capitulos2.PNG";
import "./style.scss";
import CountdownDTime from "../CountdownDateTime";
import ImgBannerAward from "../../assets/imagens//Logo-PremioEbit-03.png";


import { Link } from "react-router-dom";
import { string } from "prop-types";

const BannerCarousel = () => {
  function ControlledCarousel() {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
      setIndex(selectedIndex);
    };

    // text contagem regressiva
    const [num, setNum] = useState(100);
    const [pause, setPause] = useState(false);

    let intervalRef = useRef();

    const decreaseNum = () => setNum((prev) => prev - 1);
    useEffect(() => {
      setPause(false);
      intervalRef.current = setInterval(decreaseNum, 1000);
      return () => clearInterval(intervalRef.current);
    }, []);

    const dtAward = +new Date("2021-06-15  00:00:00") - +new Date();
    let resultTime = {};
    let text1 = "Votação começa em:";
    let text2 = "Vote em sua loja favorita:";

    if (dtAward > 0) {
      resultTime = text1;     
    }else{
      resultTime = text2;
    }

    return (
      <Carousel activeIndex={index} onSelect={handleSelect}>
        {/* <Carousel.Item>
                    <img
                        className="img-carousel"
                        src={Banner02}
                        alt="First slide"
                    />
                    <Carousel.Caption>
                        <h1 className="text-banner-1"><a href="https://company.ebit.com.br/webshoppers"> WEBSHOPPERS</a></h1>
                        <p className="text-banner-2"> <a href="https://company.ebit.com.br/webshoppers"> Confira os mais completos relatórios sobre  o mercado de e-commerce</a></p>
                    </Carousel.Caption>
                </Carousel.Item>*/}

        <Carousel.Item>
          <img className="img-carousel" src={BannerWs43} alt="Second slide" />

          <Carousel.Caption>
            <div className="img-award2021">
              <img src={ImgBannerAward} alt="Prêmio Ebit" />
            </div>
            <h1 className="text-banner-1">18º Prêmio Ebit | Nielsen</h1>

            <h2 className="text-banner-h2">
              Em breve divulgaremos os vencedores
              {/* <CountdownDTime /> */}
            </h2>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <div className="img-carousel" ></div>

          <Carousel.Caption className="banner-ws-43">
            <div className="img-vs-ws43">
              <Link to="/webshoppers">
                <img src={ImgWs43F} alt="" />
              </Link>

              <Link to="/webshoppers">
                <img src={ImgWs43P} alt="" />
              </Link>

              <Link to="/webshoppers">
                <img src={ImgWs43C} alt="" />
              </Link>
            </div>
            <div className="desc-ws-43">
              <Link to="/webshoppers">
                <h4>43º ed. Webshoppers</h4>
              </Link>
              <img src={ImgBenx} alt="" />
            </div>
          </Carousel.Caption>
        </Carousel.Item> 
      </Carousel>
    );
  }

  return <ControlledCarousel />;
};

export default BannerCarousel;
